import React from 'react';

const StepOccasion = ({
  occasions,
  occasion,
  setOccasion,
  customOccasionText,
  setCustomOccasionText,
  nickname,
  setNickname,
  onSelectOccasion,
}) => {
  const otherOption = { id: 'other', label: 'Others', img: '' };
  const allOccasions = [...occasions, otherOption];
  const isOtherSelected = occasion === otherOption.label;

  return (
    <section className="booking-card">
      <h4 className="booking-section-title">Select the Occasion</h4>
      <div className="occasion-grid">
        {occasions.length === 0 && <div className="note">No occasions available right now.</div>}
        {allOccasions.map((item) => {
          const active = occasion === item.label;
          return (
            <button
              key={item.id || item.label}
              type="button"
              className={`occasion-card${active ? ' active' : ''}`}
              onClick={() => {
                setOccasion(item.label);
                if (onSelectOccasion) {
                  onSelectOccasion(item);
                }
                if (item.label !== otherOption.label && setCustomOccasionText) {
                  setCustomOccasionText('');
                }
              }}
            >
              {item.img && <img src={item.img} alt={item.label} />}
              <span className="occasion-label">{item.label}</span>
              {active && <span className="occasion-check bi bi-check-lg" />}
            </button>
          );
        })}
      </div>
      {isOtherSelected && (
        <div className="form-group">
          <label>
            Other occasion <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Type here"
            value={customOccasionText}
            onChange={(e) => setCustomOccasionText(e.target.value)}
          />
          {!customOccasionText.trim() && <div className="error-text">This field is required</div>}
        </div>
      )}
      <div className="form-group">
        <label>
          Nick name <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Type here"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
        />
        {!nickname && <div className="error-text">This field is required</div>}
      </div>
    </section>
  );
};

export default StepOccasion;
